/**
 * @description: 共享股东客源报表
 * @author: lyr
*/
<template>
    <div class="mr-ggky-report">
        <div class="list">
            <el-form :inline="true" size="small" :model="list_form">
                <el-form-item label="注册时间">
                    <div class="clearfix" ref="list_date">
                        <el-col :span="11">
                            <el-input placeholder="开始时间" v-model="list_form.start_time"></el-input>
                        </el-col>
                        <el-col class="el-line" :span="2">-</el-col>
                        <el-col :span="11">
                            <el-input placeholder="结束时间" v-model="list_form.end_time"></el-input>
                        </el-col>
                    </div>
                </el-form-item>
                <el-form-item label="门店">
                    <el-select v-model="list_form.shop_id" filterable clearable placeholder="请选择门店">
                        <el-option v-for="item in shop_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input placeholder="请输入内容" v-model="list_form.content">
                        <el-select class="el-slot-select" v-model="list_form.select" slot="prepend" placeholder="请选择">
                            <el-option label="会员卡号" value="vip_card"></el-option>
                            <el-option label="会员手机号" value="vip_mobile"></el-option>
                            <el-option label="会员姓名" value="vip_name"></el-option>
                        </el-select>
                    </el-input>
                </el-form-item>
                <el-form-item label="会员等级">
                    <el-select v-model="list_form.level" filterable clearable placeholder="请选择会员等级">
                        <el-option v-for="item in vip_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="归属股东手机号">
                    <el-input placeholder="请输入手机号" v-model="list_form.shareholder_vip_mobile" clearable></el-input>
                </el-form-item>
                <el-form-item label="归属股东卡号">
                    <el-input placeholder="请输入卡号" v-model="list_form.shareholder_vip_card" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="listQuery">查询</el-button>
                    <el-button @click="listtExport">导出</el-button>
                </el-form-item>
            </el-form>
            <el-table
                v-loading="loading"
                element-loading-text="努力加载中，请稍后..."
                element-loading-background="rgba(0, 0, 0, 0.6)"
                :data="list_table">
                <el-table-column prop="activation_time" label="注册时间"></el-table-column>
                <el-table-column prop="shop_name" label="门店"></el-table-column>
                <el-table-column prop="vip_level_name" label="会员等级"></el-table-column>
                <el-table-column prop="vip_card" label="会员卡号"></el-table-column>
                <el-table-column prop="username" label="会员姓名"></el-table-column>
                <el-table-column prop="mobile" label="会员手机号"></el-table-column>
                <el-table-column prop="come_shop_num" label="到店次数"></el-table-column>
                <el-table-column prop="consumption" label="累计消费"></el-table-column>
                <el-table-column prop="bonus" label="累计带来分红"></el-table-column>
                <el-table-column prop="shareholder_username" label="归属股东姓名"></el-table-column>
                <el-table-column prop="shareholder_mobile" label="归属股东手机号"></el-table-column>
                <el-table-column prop="shareholder_vip_card" label="归属股东卡号"></el-table-column>
            </el-table>
            <el-pagination
                background
                layout="total, prev, pager, next, jumper"
                :page-size="GLOBAL.PAGESIZE"
                :current-page.sync="list_page"
                :total="list_total"
                @current-change="getList">
            </el-pagination>
        </div>
    </div>
</template>
<script>
    import Vue from 'vue';
    export default {
        name: 'ggky-report',
        data() {
            return {
                loading: false,
                shop_list: [],
                vip_list: [],
                list_form: {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    content: '',
                    select: 'vip_card',
                    level: '',
                    shareholder_vip_mobile: '',
                    shareholder_vip_card: '',
                },
                list_table: [],
                list_page: 1,
                list_total: 0,
            }
        },
        watch: {
            '$route': {
                handler: function(val, oldVal) {
                    if (val.params.shareholder_vip_card) {
                        this.list_form = {
                            start_time: '',
                            end_time: '',
                            shop_id: '',
                            content: '',
                            select: 'vip_card',
                            level: '',
                            shareholder_vip_mobile: '',
                            shareholder_vip_card: val.params.shareholder_vip_card,
                        }
                        this.getList(1);
                    }
                },
                deep: true
            },
        },
        mounted: function() {
            // 日期
            this.innitDate();
            // 页面跳转第一次打开
            if(this.$route.params.shareholder_vip_card) {
                this.list_form = {
                    start_time: '',
                    end_time: '',
                    shop_id: '',
                    content: '',
                    select: 'vip_card',
                    level: '',
                    shareholder_vip_mobile: '',
                    shareholder_vip_card: this.$route.params.shareholder_vip_card,
                }
            }
            new Promise(resolve => {
                this.getShop(resolve)
            }).then(res => {
                if (this.$route.params.shareholder_vip_card) { // 页面跳转第一次打开
                    this.list_form.shop_id = ''
                }else {
                    this.list_form.shop_id = this.shop_list[0].id;
                }
                this.getVipLevelCombo()
                this.getList(1);
            })
        },
        methods: {
            // 初始化日期插件
            innitDate: function() {
                const _this = this;
                $(_this.$refs.list_date).daterangepicker({
                    buttonClasses: ['btn btn-default'],
                    applyClass: 'btn-small btn-orange',
                    cancelClass: 'btn-small btn-gray',
                    startDate: moment().toDate(),
                    endDate: moment().add(1, 'day').toDate(),
                }, function(start, end, label) {
                    _this.list_form.start_time = start.format('YYYY-MM-DD 08:00');
                    _this.list_form.end_time = end.format('YYYY-MM-DD 08:00');
                });
            },

            // 初始化门店输入框
            getShop: function(resolve) {
                const _this = this;

                Vue.axios.post('PublicData/api_getShopListByPurview', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.shop_list = res.data.response.result;
                        _this.shop_list.shift();
                        resolve()
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            // 获取会员卡等级
            getVipLevelCombo: function() {
                const _this = this;

                Vue.axios.post('Vip/getVipLevelCombo', {
                    "header": Vue.request_header,
                    "request": {
                        "version": Vue.version,
                        "param": {}
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        _this.vip_list = res.data.response.result;
                        _this.vip_list.unshift({
                            id: '',
                            name: '全部'
                        })
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg('出错啦');
                });
            },

            getList(page) {
                const _this = this;

                _this.loading = true;
                let vip_card = "",
                    vip_name = "",
                    vip_mobile = "";
                if(_this.list_form.select == 'vip_card') {
                    vip_card = _this.list_form.content;
                } else if(_this.list_form.select == 'vip_name') {
                    vip_name = _this.list_form.content;
                } else if(_this.list_form.select == 'vip_mobile') {
                    vip_mobile = _this.list_form.content;
                }
                Vue.axios.post('FinanceReport2/getVipShareholderSubordinateList', {
                    "header": Vue.request_header,
                    "request": {
                        "param": {
                            "page": page,
                            "page_size": _this.GLOBAL.PAGESIZE,
                            "start_time": _this.list_form.start_time,
                            "end_time": _this.list_form.end_time,
                            "shop_id": _this.list_form.shop_id,
                            "vip_card": vip_card,
                            "vip_name": vip_name,
                            "vip_mobile": vip_mobile,
                            "level": _this.list_form.level,
                            "shareholder_vip_mobile": _this.list_form.shareholder_vip_mobile,
                            "shareholder_vip_card": _this.list_form.shareholder_vip_card
                        }
                    },
                    "comment": ""
                })
                .then(res => {
                    if(res.data.response.result_code == "true") {
                        if(page == 1) {
                            _this.list_total = Number(res.data.response.result.data.total);
                        }
                        _this.list_table = res.data.response.result.data.rows;
                        _this.loading = false;
                    } else {
                        Vue.timeoutfun(res.data.response.result_status, _this);
                        layer.msg(res.data.response.error_msg);
                    }
                })
                .catch(err => {
                    layer.msg("出错啦");
                });
            },

            // 查询
            listQuery() {
                this.list_page = 1
                this.getList(this.list_page);
            },

            listtExport: function() {
                let vip_card = "",
                    vip_name = "",
                    vip_mobile = "";
                if(this.list_form.select == 'vip_card') {
                    vip_card = this.list_form.content;
                } else if(this.list_form.select == 'vip_name') {
                    vip_name = this.list_form.content;
                } else if(this.list_form.select == 'vip_mobile') {
                    vip_mobile = this.list_form.content;
                }
                window.location.href = Vue.ctUrl + "FinanceReport2/exportVipShareholderSubordinateList" +
                    "?start_time=" + this.list_form.start_time +
                    "&end_time=" + this.list_form.end_time +
                    "&shop_id=" + this.list_form.shop_id +
                    "&vip_card=" + vip_card +
                    "&vip_name=" + vip_name +
                    "&vip_mobile=" + vip_mobile +
                    "&level=" + this.list_form.level +
                    "&shareholder_vip_mobile=" + this.list_form.shareholder_vip_mobile +
                    "&shareholder_vip_card=" + this.list_form.shareholder_vip_card;
                layer.msg("导出成功！");
            },
        }
    }
</script>
<style lang="less" scoped>

</style>